// From `not_yet_begun` to `understanding`
export const BEGIN_ANSWER = 'begin_answer';

// From `understanding` to `clarifying`
export const CLARIFY = 'clarify';

// From `clarifying` to `waiting_reply`
export const WAITING = 'waiting';

// From `waiting_reply` to `mark_question_complete`
export const ACCOMPLISH = 'accomplish';



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/constants/chatActions.js